import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './transfer_complete.less'
import { formatMoney } from 'client/griffin'
import StandardError from 'components/common/standard_error'
import { toCFPBStringId } from 'client/lib/cfpb'

const i18n = getI18n('components/edit_glimpse/transfer')

class TransferComplete extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.number,
    currency: PropTypes.string.isRequired,
    transferError: PropTypes.any,
    onDone: PropTypes.func.isRequired,
    fromVenice: PropTypes.bool.isRequired,
  }

  shouldComponentUpdate(nextProps, nextState) {
    // since the form this relies on might be destroyed while this transitions, we don't want to re-render if amount is non-existent.
    return nextProps.amount != null
  }

  render() {
    if (this.props.transferError) {
      return <StandardError iconType="warning" title={i18n('transfer_error')} />
    }

    const { fromVenice } = this.props

    return (
      <div>
        <span
          className="icon icon-large icon-circled-checkmark-large"
          styleName="create-indicator"
        />
        <div styleName="title">
          {i18n(toCFPBStringId('complete_title'), {
            amount: formatMoney(this.props.currency, this.props.amount),
            title: this.props.title,
          })}
        </div>
        <div styleName="sub-title">
          {i18n(toCFPBStringId('complete_sub_title'))}
        </div>
        <div styleName="actions">
          {!fromVenice && (
            <button
              data-pa-click="done"
              onClick={this.props.onDone}
              data-nemo="transfer-done-button"
              className="vx_btn vx_btn-block"
              styleName="done-button"
            >
              {i18n('done')}
            </button>
          )}
          <a
            data-pa-click="withdraw"
            href="https://www.paypal.com/myaccount/wallet/withdraw"
            className="vx_btn vx_btn-block vx_btn-secondary"
          >
            {i18n('withdraw_to_bank')}
          </a>
        </div>
      </div>
    )
  }
}

export default cssModules(TransferComplete, styles)
